
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
const meta = {};
const slug = '_whytradly';
const tableOfContents = [{
  "title": "3 Reasons Why Tradly Fleet",
  "slug": "3-reasons-why-tradly-fleet",
  "children": []
}];

const layoutProps = {
  meta,
slug,
tableOfContents
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`With Tradly Fleets, You don’t just get the fundamental fleet and delivery features but `}</p>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Admin Panel for all your team members`}</li>
      <li parentName="ul">{`No restriction on number of location or drivers `}</li>
      <li parentName="ul">{`No restriction on number of team members accessing the admin `}</li>
      <li parentName="ul">{`Android and iOS app for Delivery Team`}</li>
      <li parentName="ul">{`Commerce & marketplace infrastructure if you are starting a new business (Optional) `}</li>
      <li parentName="ul">{`Developer focused features for business expansion (Headless API, Webhooks, Open-source kits)`}</li>
    </ul>
    <_Heading level={2} id={"3-reasons-why-tradly-fleet"} nextElement={{
      "type": "list",
      "ordered": true,
      "start": 1,
      "spread": false
    }}>3 Reasons Why Tradly Fleet</_Heading>
    <ol {...{
      "role": "list"
    }}>
      <li parentName="ol">{`Sign Up and Getting Started doesn’t take more than a few minutes. No sales call or negotiation, it’s transparent, and it’s just there.  `}</li>
      <li parentName="ol">{`Easily start running the operation with SuperDelivery app already available in App Store and Playstore. No need to wait for app deployments or a demo session to test the delivery app.`}</li>
      <li parentName="ol">{`Your customers, Your Developers, Driver team will have a delightful experience. We follow simple and fast as principle on everything we do. Hence, all your stakeholders will save time using any part of the solution. `}</li>
    </ol>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
